if (!customElements.get('dl-mobile-purchase')) {
  customElements.define('dl-mobile-purchase', class extends HTMLElement {
    connectedCallback() {
      this.scope = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.proxy = this.querySelector('[data-mobile-submit]');
      this.label = this.querySelector('[data-mobile-label]');
      this.price = this.querySelector('[data-mobile-price-content]');
      this.selection = this.querySelector('[data-mobile-selection]');
      this.error = this.querySelector('[data-mobile-error]');
      if (!this.scope || !this.proxy) {
        this.hidden = true;
        return;
      }
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.sync = () => this.update();
      this.onClick = event => {
        event.preventDefault();
        const main = this.mainButton();
        if (!main || main.disabled || main.getAttribute('aria-disabled') === 'true' || main.classList.contains('loading')) return;
        const form = document.getElementById(this.dataset.formId);
        if (form && !form.checkValidity()) {
          form.reportValidity();
          const invalid = Array.from(form.elements).find(input => input.willValidate && !input.validity.valid);
          invalid?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        main.click();
      };
      this.proxy.addEventListener('click', this.onClick);
      this.mobile.addEventListener('change', this.sync);
      this.mutations = new MutationObserver(this.sync);
      this.mutations.observe(this.scope, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class', 'hidden'] });
      this.visibility = new IntersectionObserver(this.sync, { threshold: [0, 1] });
      const main = this.mainButton();
      if (main) this.visibility.observe(main);
      this.resize = new ResizeObserver(() => {
        document.body.style.setProperty('--dl-mobile-purchase-height', `${this.getBoundingClientRect().height}px`);
      });
      this.resize.observe(this);
      this.update();
    }
    mainButton() {
      return this.scope?.querySelector('.single-add-to-cart-button');
    }
    update() {
      const main = this.mainButton();
      if (!main) {
        this.hidden = true;
        document.body.classList.remove('dl-mobile-purchase-active');
        return;
      }
      const box = main.getBoundingClientRect();
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      const isVisible = box.height > 0 && box.top >= 0 && box.bottom <= viewportHeight;
      this.hidden = !this.mobile.matches || isVisible;
      document.body.classList.toggle('dl-mobile-purchase-active', this.mobile.matches && !this.hidden);
      this.proxy.disabled = main.disabled || main.getAttribute('aria-disabled') === 'true' || main.classList.contains('loading');
      this.proxy.setAttribute('aria-busy', String(main.classList.contains('loading')));
      this.label.textContent = main.querySelector('.single-add-to-cart-button--text')?.textContent.trim() || main.textContent.trim();
      if (this.selection) {
        const selected = Array.from(this.scope.querySelectorAll('variant-selects:not([data-sticky]) input[type="radio"]:checked, variant-selects:not([data-sticky]) select'), input => input.value);
        this.selection.textContent = selected.filter(value => value && value !== 'Default Title').join(' · ');
      }
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price && this.price.innerHTML !== price.innerHTML) this.price.innerHTML = price.innerHTML;
      const error = this.scope.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
      this.error.textContent = error?.textContent.trim() || '';
    }
    disconnectedCallback() {
      this.proxy?.removeEventListener('click', this.onClick);
      this.mobile?.removeEventListener('change', this.sync);
      this.mutations?.disconnect();
      this.visibility?.disconnect();
      this.resize?.disconnect();
      document.body.classList.remove('dl-mobile-purchase-active');
      document.body.style.removeProperty('--dl-mobile-purchase-height');
    }
  });
}
